var Button_module_default = {
	button: "_button_1nw83_8",
	"icon-only": "_icon-only_1nw83_53",
	"has-icon": "_has-icon_1nw83_60",
	destructive: "_destructive_1nw83_110"
};
//#endregion
export { Button_module_default as default };

//# sourceMappingURL=Button.module.js.map